import { type FC } from 'react';
import { Pagination, Form } from 'react-bootstrap';

import { usePagination, DOTS } from './usePagination';
import {
	paginationBlock,
	paginationWrapper
} from '../../containers/PageElementsPage/components/GeoMap/styles';
import { DEFAULT_ROW_DISPLAY_COUNT, ROW_DISPLAY_COUNT_OPTIONS } from './constants';

interface Props {
	totalCount: number;
	siblingCount?: number;
	currentPage: number;
	onPageChange: (_) => void;
	pageSize: number;
	setPageSize: (_) => void;
}

const PaginationBlock: FC<Props> = (props) => {
	const { totalCount, siblingCount = 1, currentPage, onPageChange, pageSize, setPageSize } = props;

	const paginationRange = usePagination({
		currentPage,
		totalCount,
		siblingCount,
		pageSize
	});

	const onNext = () => {
		onPageChange(currentPage + 1);
	};

	const onPrevious = () => {
		onPageChange(currentPage - 1);
	};

	const lastPage = paginationRange[paginationRange.length - 1];

	return (
		<div className={paginationWrapper}>
			<div>
				<Form.Control
					as="select"
					className="rowsNumberSelect"
					defaultValue={DEFAULT_ROW_DISPLAY_COUNT}
					onChange={(e) => setPageSize(+e.target.value)}>
					{ROW_DISPLAY_COUNT_OPTIONS.map((number, index) => (
						<option key={index} value={number}>
							{number}
						</option>
					))}
					<option value={totalCount}>All</option>
				</Form.Control>
				<Form.Label>Show rows</Form.Label>
			</div>

			<Pagination className={paginationBlock}>
				<Pagination.Prev disabled={currentPage === 1} onClick={onPrevious} />

				{paginationRange.map((pageNumber, index) => {
					if (pageNumber === DOTS) {
						return <Pagination.Ellipsis key={index} />;
					}

					return (
						<Pagination.Item
							key={index}
							active={pageNumber === currentPage}
							onClick={() => onPageChange(pageNumber)}>
							{pageNumber}
						</Pagination.Item>
					);
				})}

				<Pagination.Next disabled={currentPage === lastPage} onClick={onNext} />
			</Pagination>

			<div />
		</div>
	);
};

export default PaginationBlock;
